import { computed, ref } from 'vue';
import type { GenericField } from '@Types';
import type { FieldInitialSettings, FieldSchema, RawField } from '@FormModule';
import { filterFieldsAccordingToTemplateHelper } from '../helpers';
import { useForm } from '@FormModule';

const animalId = ref();
const currentSchemaModels = ref<Set<GenericField>>(new Set());
const fieldsSchema = ref<FieldSchema[]>([]);
const formError = ref();
const formId = ref('');
const formName = ref('');
const formTemplateId = ref('');
const formTemplateName = ref('');
const formTitle = ref('');
const formType = ref('');
const intakeFormType = ref('');
const kennels = ref();
const rawFields = ref<RawField[]>([]);
const initialFormTemplate = ref('null');
const templateFields = ref();

export default function () {
  const { getDetailsSchema } = useForm();

  const hasVisualKennel = computed(() => {
    if (!kennels.value) return;

    return kennels?.value?.find((kennel: any) => kennel?.name);
  });
  const fieldsSettings = computed(
    (): FieldInitialSettings => ({
      kennel: {
        edit: {
          label: hasVisualKennel.value ? 'name' : '',
          options: kennels.value,
        },
      },
      age: {
        edit: {
          label: 'value',
        },
      },
      secondary_color_map: {
        edit: {
          label: 'value',
        },
      },
      tertiary_color_map: {
        edit: {
          label: 'value',
        },
      },
      coat_length: {
        edit: {
          label: 'value',
        },
      },
      size: {
        edit: {
          label: 'value',
        },
      },
      animal_name: {
        label: 'Animal Name',
        settings: {
          type: 'animal_name',
        },
      },
      birthday: {
        settings: {
          estBirthday: 'estimated',
          noModelOnStart: true,
        },
      },
      animal_template: {
        model: initialFormTemplate.value,
      },
      breed: {
        edit: {
          options: [],
        },
        settings: {
          type: 'breeds',
        },
      },
      secondary_breed: {
        edit: {
          options: [],
        },
        settings: {
          type: 'select',
        },
      },
      photo: {
        settings: {
          type: 'file',
          multiple: true,
          fileLimit: 5,
        },
      },
      species: {
        model: [],
        edit: {
          options: [],
        },
        settings: {
          show: true,
        },
      },
      microchip: {
        settings: {
          type: 'microchip',
        },
      },
    })
  );

  const selectedTemplate = computed(() => fieldsSchema.value.find(({ name }) => name === 'animal_template'));
  const formTemplate = computed(() => selectedTemplate.value?.model);

  function setForm() {
    fieldsSchema.value = getDetailsSchema(rawFields.value, fieldsSettings.value);

    const types = ['select', 'radio', 'checkbox', 'multiselect'];
    fieldsSchema.value.forEach((field) => {
      if (types.includes(field?.settings?.type || '') && !field?.edit?.options?.length) {
        field.settings.show = false;
        field.settings.required = false;
      }
    });

    filterFieldsAccordingToTemplateHelper(fieldsSchema, templateFields);
  }

  function resetForm() {
    currentSchemaModels.value = new Set();
    fieldsSchema.value = [];
  }

  return {
    animalId,
    currentSchemaModels,
    fieldsSchema,
    fieldsSettings,
    formError,
    formId,
    formName,
    formTemplate,
    formTemplateId,
    formTemplateName,
    formTitle,
    formType,
    intakeFormType,
    kennels,
    rawFields,
    resetForm,
    setForm,
    initialFormTemplate,
    templateFields,
  };
}
